import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import MCSOverlayLoading from "../../components/MCSOverlayLoading";
import MCSReadonlyField from "../../components/MCSReadonlyField";
import DafTabRequestList from "./Components/DafTabRequestList";
import { GlobalAlertContext } from "../../context/GlobalAlertContext";
import { DafUploadRoutes } from "../../_constants/PageRoutes";
import { DafHelper } from "../../_helpers/DafHelper";

const ManageDafRequest = () => {
  const { promiseInProgress } = usePromiseTracker();
  const location = useLocation();
  const history = useHistory();
  const [dafUpload, setDafUpload] = useState(null);
  const [hasDafUploadLog, setHasDafUploadLog] = useState(false);
  const downloadErrorLogStyle = { backgroundColor: "#9B0000"};
  const returnToUploadFileListPage = () => {
    history.push(DafUploadRoutes.DAF_UPLOAD_LIST);
  };

  const downloadDafUploadLog = async (alertObj) => {
    await DafHelper.DownloadErrorLog(dafUpload.id, alertObj);
  };

  useEffect(() => {
    setDafUpload(location.state.dafUpload);
    setHasDafUploadLog(location.state.dafUpload && location.state.dafUpload.hasDafUploadLog);
  }, []);

  if (!dafUpload) {
    return <MCSOverlayLoading></MCSOverlayLoading>;
  }

  return (
    <>
      {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
      <GlobalAlertContext.Consumer>
        {(alertObj) => (
          <>
            <Grid>
              <Row>
                <Col>
                  <Typography tag="h1">File Details</Typography>
                </Col>
              </Row>
              <Row>
                <Col>
                  <MCSReadonlyField
                    label="File Name"
                    text={dafUpload.fileName}
                  />
                  <ButtonGroup direction="right">
                    <ButtonText colorScheme="primary"
                      style={hasDafUploadLog ? downloadErrorLogStyle : {}}
                      disabled={!hasDafUploadLog}
                      onClick={() => downloadDafUploadLog(alertObj)}>Download VSS Error Log</ButtonText>
                  </ButtonGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <DafTabRequestList
                    dafUpload={dafUpload}
                    alertObj={alertObj}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ButtonGroup direction="right">
                    <ButtonText colorScheme="secondary" onClick={returnToUploadFileListPage}>Back</ButtonText>
                  </ButtonGroup>
                </Col>
              </Row>
            </Grid>
          </>
        )}
      </GlobalAlertContext.Consumer>
    </>
  );
};
export default ManageDafRequest;
